var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletReadyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_360_12089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "#11A811",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "url(#paint0_linear_360_12089)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 8.5C66.9492 8.5 81.5 23.0508 81.5 41C81.5 58.9493 66.9493 73.5 49 73.5C31.0507 73.5 16.5 58.9493 16.5 41C16.5 23.0508 31.0508 8.5 49 8.5Z",
    stroke: "#BBF9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 41.5468V35.4535C36.3333 33.8668 37.3066 32.4534 38.7866 31.8934L49.3732 27.8934C51.0266 27.2667 52.7999 28.4935 52.7999 30.2668V35.3335",
    fill: "#DCFDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 41.5468V35.4535C36.3333 33.8668 37.3066 32.4534 38.7866 31.8934L49.3732 27.8934C51.0266 27.2667 52.7999 28.4935 52.7999 30.2668V35.3335",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0532 43.0668C56.4932 43.6135 56.1733 44.4002 56.2533 45.2402C56.3733 46.6802 57.6933 47.7335 59.1333 47.7335H61.6666V49.3202C61.6666 52.0802 59.4133 54.3336 56.6533 54.3336H43.1733C43.5866 53.9869 43.9466 53.5602 44.2266 53.0802C44.7199 52.2802 44.9999 51.3336 44.9999 50.3336C44.9999 47.3869 42.6133 45.0002 39.6666 45.0002C38.4133 45.0002 37.2533 45.4402 36.3333 46.1735V40.3469C36.3333 37.5869 38.5866 35.3335 41.3466 35.3335H56.6533C59.4133 35.3335 61.6666 37.5869 61.6666 40.3469V42.2669H58.9732C58.2266 42.2669 57.5466 42.5602 57.0532 43.0668Z",
    fill: "#DCFDDB",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0783 43.627V46.3738C63.0783 47.1071 62.4917 47.7071 61.745 47.7337H59.1317C57.6917 47.7337 56.3717 46.6804 56.2517 45.2404C56.1717 44.4004 56.4917 43.6137 57.0517 43.0671C57.545 42.5604 58.225 42.2671 58.9717 42.2671H61.745C62.4917 42.2938 63.0783 42.8937 63.0783 43.627Z",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3333 41H51.6666",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 50.3334C44.9999 51.3334 44.7199 52.28 44.2266 53.08C43.9466 53.56 43.5866 53.9867 43.1733 54.3334C42.2399 55.1734 41.0133 55.6667 39.6666 55.6667C37.7199 55.6667 36.0266 54.6267 35.1066 53.08C34.6133 52.28 34.3333 51.3334 34.3333 50.3334C34.3333 48.6533 35.1066 47.1467 36.3333 46.1733C37.2533 45.44 38.4133 45 39.6666 45C42.6133 45 44.9999 47.3867 44.9999 50.3334Z",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5884 50.3328L38.9084 51.6528L41.7484 49.0261",
    stroke: "#F7FEF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_360_12089",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 16,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_360_12089"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_360_12089"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_360_12089"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.976471 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_360_12089",
    result: "effect2_dropShadow_360_12089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_360_12089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_12089",
    x1: 17,
    y1: 9,
    x2: 81.0001,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#1DCB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#46E345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletReadyIcon);
export default __webpack_public_path__ + "static/media/WalletReadyIcon.1b617c8d8b68ec9899dabc4443f6cc1f.svg";
export { ForwardRef as ReactComponent };